/* faqController.js */

import breakpoints from './breakpoints';

export default function () {
    let faqEl = document.querySelector('.faq-categories-container');

    if(faqEl){
      let catBtns = document.querySelectorAll('.category-filter-button');
      let faqElBtn = document.querySelectorAll('.faq-accordion-header-button');

      for(const [i, btn] of catBtns.entries()) {
          btn.addEventListener('click', () => showFAQCategory(btn));
      }

      for (const btn of faqElBtn) {
          let iconEl = btn.closest('.faq-accordion-el').querySelector('.icons-ArrowUpIcon');
          btn.addEventListener('click', () => toggleFAQAnswer(btn));
          iconEl.addEventListener('click', () => toggleFAQAnswer(btn));
      }
    }
}

//toggle faq category visible/hidden
function showFAQCategory(trigger) {
    let parentContainer = trigger.closest('.faq-container');
    let catID = trigger.dataset.cattoggles;
    let categoryContainers = parentContainer.querySelectorAll('.faq-category-el');
    let categoryBtns = parentContainer.querySelectorAll('.category-filter-button');

    for(const [i,cat] of categoryContainers.entries()) {
       if(cat.dataset.faqid === catID) {
           if (cat.classList.contains('hidden')) {
               let txtIconEl = trigger.querySelectorAll('span');
               for (const el of txtIconEl) {
                   el.classList.add('text-white');
                   el.classList.add('img--invert');
               }
               trigger.classList.add('!border-blue-light');
               trigger.classList.add('!bg-blue-light');
               cat.classList.remove('hidden');
           }
       } else if(!cat.classList.contains('hidden')){
           let txtIconEl = categoryBtns[i].querySelectorAll('span');
           for (const el of txtIconEl) {
               el.classList.remove('text-white');
               el.classList.remove('img--invert');
           }
           categoryBtns[i].classList.remove('!border-blue-light');
           categoryBtns[i].classList.remove('!bg-blue-light');
           cat.classList.add('hidden');
       }
    }
}

//Toggle FAQ accordion answer
function toggleFAQAnswer(trigger) {
    let answerID = trigger.dataset.faqanswer;
    let parentCatEl = trigger.closest('.faq-category-el');
    let answerEls = parentCatEl.querySelectorAll('.faq-accordion-body');

    for(const el of answerEls) {
        if(el.dataset.faqid === answerID) {
            if(el.classList.contains('hidden')) {
                let arrIcon = el.closest('.faq-accordion-el').querySelector('.icons-ArrowUpIcon');
                arrIcon.classList.remove('rotate-180');
                el.classList.remove('hidden');
            } else {
                let arrIcon = el.closest('.faq-accordion-el').querySelector('.icons-ArrowUpIcon');
                arrIcon.classList.add('rotate-180');
                el.classList.add('hidden');
            }
        } else if (!el.classList.contains('hidden')) {
            let arrIcon = el.closest('.faq-accordion-el').querySelector('.icons-ArrowUpIcon');
            arrIcon.classList.add('rotate-180');
            el.classList.add('hidden');
        }
    }
}

function checkContentOverflow() {
    var faqElements = document.querySelectorAll('.faq-container');
    for (const el of faqElements) {
        var slider = el.querySelector('.slider');
        var wrapper = el.querySelector('.swiper-wrapper');

        console.log(wrapper.scrollWidth - slider.offsetWidth);

        if ((wrapper.scrollWidth - slider.offsetWidth) >= 60) {
            el.querySelector('.slider-controls-container').style.display = 'flex';
        } else {
            el.querySelector('.slider-controls-container').style.display = 'none';
        }
    }
}
document.addEventListener('DOMContentLoaded', () => {
    if (document.querySelector('.faq-container')) {
        checkContentOverflow();
        window.addEventListener('resize', checkContentOverflow);
    }
});
